import maintainerApi from 'api/maintainerApi';
import MaintainerHelper from './maintainerHelper';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay danh sach dai ly
export const thunkGetMaintainerList = createAsyncThunk(
    'maintainer/thunkGetMaintainerList',
    async ({ params }, thunkAPI) => {
        const res = await maintainerApi.getMaintainerList(params);
        return res;
    }
);

// ---- params ----
const initialState = {
    isGettingData: false,
    maintainerList: [],
    maintainerTotal: 0,
};

const maintainerSlice = createSlice({
    name: 'maintainer',
    initialState,
    reducers: {
        resetMaintainerState: (state) => {
            Object.assign(state, initialState);
        },
    },
    extraReducers: {
        [thunkGetMaintainerList.pending]: (state, action) => {
            state.isGettingData = true;
        },
        [thunkGetMaintainerList.rejected]: (state, action) => {
            state.isGettingData = false;
        },
        [thunkGetMaintainerList.fulfilled]: (state, action) => {
            state.isGettingData = false;
            const { result, maintainers, total } = action.payload;
            if (result === 'success') {
                state.maintainerList = maintainers;
                state.maintainerTotal = total;
            }
        },
    },
});

const { reducer, actions } = maintainerSlice;
export const { resetMaintainerState } = actions;
export default reducer;
